import type { Author } from '@bulknutrients/bulk-shared-lib/interfaces/Expert';
import { AuthorSocialLinks } from '@components/Author/AuthorSocialLinks';
import { CustomImage } from '@components/Media/Image';
import { PortableTextBlockRenderer } from '@components/PortableText/PortableText';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import type React from 'react';
import type { ReactElement } from 'react';

export function BlogAuthorBlurb({ author }: { author: Author }): ReactElement {
  return (
    <div className="flex flex-col items-center">
      {author.image && (
        <CustomImage
          image={
            author.slug && author.profilePage
              ? { ...author.image, internalLink: author.slug }
              : author.image
          }
          width={300}
          height={300}
          round
        />
      )}
      <p className="text-center text-lg">
        {author.slug && author.profilePage ? (
          <TextLink href={author.slug}>{author.name}</TextLink>
        ) : (
          author.name
        )}
      </p>
      <AuthorSocialLinks author={author} />
      {author.shortDescription && (
        <PortableTextBlockRenderer content={author.shortDescription} />
      )}
      {author.slug && author.profilePage && (
        <TextLink
          href={author.slug}
          style={
            {
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
              width: 'fit-content',
            } as React.CSSProperties
          }
        >
          More about {author.name}
        </TextLink>
      )}
    </div>
  );
}
